<div id="background"></div>
<ng-container *ngIf="initialize">
  <header class="header">
    <img src="/assets/collabo-portal/images/logo.svg" />
  </header>

  <div class="container isBackgoround" style="padding: 0">
    <main>
      <div
        class="text-center mb-6"
        style="
          background: #dcedc8;
          height: 188px;
          display: flex;
          justify-content: center;
        "
      >
        <img
          src="/assets/doctors-station/images/checked.svg"
          width="100"
          height="100"
          alt="DoctorsStation"
        />
      </div>

      <div class="container_min">
        <h2 class="text-h6 font-weight-bold text-center mb-6">
          ロックを解除しました
        </h2>
        <p class="text-caption text-subtitle-1 text-center mb-6">
          あなたのアカウントのロックが解除されました。<br />
          {{ countdown }}秒後に、コラボポータルのトップページへ自動的に移動します。
        </p>
        <p class="text-caption text-center mb-6">
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>

        <div class="mb-6">
          <button (click)="redirect()" class="resetButton font-weight-bold">
            トップに戻る
          </button>
        </div>
      </div>
    </main>
  </div>
</ng-container>
